import { useState, useEffect, useRef } from 'react';
import styles from './LyricsDisplay.module.css';

const albumLyrics = {
    eia: [
        "I was your robot companion,\nyou were my favorite color",
        "And the waters are warm,\nwhere they used to run freezing",
        "When it all looks like heaven\nbut it feels like hell...",
        "It seems that even in arcadia,\nyou walk beside me still",
    ],
    tmbte: [
        "So if your wings won't find you heaven\nI will bring it down like an ancient bygone",
        "I was more than just a body in your passenger seat\nAnd you were more than just somebody I was destined to meet",
        "Just let me go or take me with you",
        "Who made you like this?\nWho encrypted your dark gospel in body language?",
    ],
    tpwbyt: [
        "Seems your heart is locked up and I still get the combination wrong\nOr are you simply waiting to save your love for someone I am not?",
        "You will be mine",
        "Won't you fall for me?\nThrough a fractured existence\nWon't you fall for me?",
        "But I won't turn away, it's far too late for me\n'Cause I am broken into fractions",
    ],
    sundowning: [
        "I'm still your favorite regret\nYou're still my weapon of choosing",
        "Turn the page once again\nGive up the game and let me in",
        "And you know I'll be yours\nJust want to be worth it",
        "I will be watching for your enemies\nTo let them know that they contend with me",
        "And when we met, I could see dark signs\nAlarm bells in your eyes",
    ],
};

function LyricsDisplay({ albumId, titleVisible }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const intervalRef = useRef(null);
    const indexRef = useRef(0);

    const lyrics = albumLyrics[albumId] || [];

    const startInterval = (lyricsLength) => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            setVisible(false);
            setTimeout(() => {
                indexRef.current = (indexRef.current + 1) % lyricsLength;
                setCurrentIndex(indexRef.current);
                setVisible(true);
            }, 800);
        }, 6000);
    };

    // quando muda de album
    useEffect(() => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        indexRef.current = 0;
        setCurrentIndex(0);
        setVisible(false);
    }, [albumId]);

    // quando titulo reaparece, mostra lyrics e inicia intervalo
    useEffect(() => {
        if (titleVisible) {
            const timer = setTimeout(() => {
                setVisible(true);
                startInterval(lyrics.length);
            }, 300);
            return () => clearTimeout(timer);
        } else {
            setVisible(false);
            if (intervalRef.current) clearInterval(intervalRef.current);
        }
    }, [titleVisible, albumId, lyrics.length]);

    useEffect(() => {
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, []);

    if (!lyrics.length) return null;

    return (
        <div className={styles.container}>
            <div className={`${styles.inner} ${visible ? styles.visible : styles.hidden}`}>
                <span className={styles.quoteOpen}>&ldquo;</span>
                <div className={styles.text}>
                    {lyrics[currentIndex].split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default LyricsDisplay;